/*
  NOTE du 12/02/2015:
  Réécriture de la lib pour permettre le chargement en bas de page.
  Les jalons sont définis inline dans la page en tant que tableau d'objet :

  window.aJalons = [
    {
      id: string, id du jalon
      t: Date, date de creation
      cid: string compare id - base comparaison
    },
    ...
  ]

  Avant, il fallait que la lib soit chargée en début de document utilisation de la fct addJalon
  pour définir un jalon.

  Objectif : chargement de la lib dans le "build" et traitement post chargement.

*/

export function zgif(jalons, app, access) {
   var oJalons = jalons || {}
   var aQs = []
   var sAccess = access || ''
   var sApp = app || ''

   if (window.location.host === 'www.preprod.orange.fr') {
      var aZgif = ['//c.woopic.com/z.gif?', '//z.preprod.woopic.com/z.gif?'] // Demande des OPS pour des test zgif en preprod (à supprimer à terme)
   } else {
      var aZgif = ['//c.woopic.com/z.gif?', '//z.woopic.com/z.gif?']
   }

   var oIpv6 = {
      finalUrl: '//statsv6.woopic.com/z.gif?',
      oImgs: {
         v4: { src: '//test-v4.woopic.com/z.gif?', time: 'na' },
         v6: { src: '//test-v6.woopic.com/z.gif?', time: 'na' },
         ds: { src: '//test-ds.woopic.com/z.gif?', time: 'na' },
      },
   }

   /*
    --------
    run
    genere les parametres de la querystring en fonction de oJalons
    --------
  */
   function run() {
      aQs.push(['APP', sApp].join('='))
      aQs.push(['access', sAccess].join('='))

      for (var i in oJalons) {
         if (oJalons.hasOwnProperty(i)) {
            var duration = getDuration(oJalons[i])
            // le jalon start sert juste de point de comparaison,
            // on ne l'integre pas dans la query string.
            if (i !== 'start') {
               aQs.push([i, duration].join('='))
            }
         }
      }
      putTime()
      ipv6()
   }

   /*
    --------
    getDuration
    retourne la duree en millisecondes entre la creation du jalon et du jalon 'cid'.
    param j : jalon
      {
      id: String, id ou nom du jalon
      t: Date, date de creation du jalon
      cid: String id ou nom du jalon a comparer
      }
    --------
  */
   function getDuration(j) {
      if (j.hasOwnProperty('cid')) {
         return j.t.getTime() - oJalons[j.cid].t.getTime()
      } else {
         return j.t.getTime()
      }
   }

   /*--------
    getCoor
    retourne les infos concernant la resolution du client
    --------
  */
   function getCoor() {
      if (document.all) {
         return (
            'size=|' +
            parseInt(document.body.clientWidth) +
            '|' +
            parseInt(document.body.clientHeight) +
            '|M|' +
            parseInt(window.screen.width) +
            '|' +
            parseInt(window.screen.height)
         )
      } else {
         return 'size=|' + window.innerWidth + '|' + window.innerHeight + '|N|' + window.outerWidth + '|' + window.outerHeight
      }
   }

   /*
    --------
    navigationTiming
    mesure des performance via l'API window.performance dans les navigateurs compatibles
    --------
  */
   function getNavigationTiming() {
      var aNtQs = []

      if (window.performance) {
         var navVersion = (function () {
            var ua = navigator.userAgent
            var N = navigator.appName
            var tem
            var M = ua.match(/(opera|chrome|safari|firefox|msie|trident)\/?\s*([\d.]+)/i) || []
            M = M[2] ? [M[1], M[2]] : [N, navigator.appVersion, '-?']
            if (M && (tem = ua.match(/version\/([.\d]+)/i)) !== null) M[2] = tem[1]
            return M.join('')
         })()

         var prms = window.performance.timing
         var navStart = prms.navigationStart

         var datas = {
            nav: navVersion,
            dls: prms.domainLookupStart - navStart,
            dle: prms.domainLookupEnd - navStart,
            cs: prms.connectStart - navStart,
            ce: prms.connectEnd - navStart,
            rqs: prms.requestStart - navStart,
            rps: prms.responseStart - navStart,
            dc: prms.domComplete - navStart,
            les: prms.loadEventStart - navStart,
            lee: prms.loadEventEnd - navStart,
         }

         for (var i in datas) {
            if (datas.hasOwnProperty(i)) {
               aNtQs.push([i, datas[i]].join('='))
            }
         }
      }

      return aNtQs.join('|')
   }

   /*
    --------
    putTime
    genere la requete z.gif qui sera logguee pour generer les graphs
    ajoute le jalon timeTotal, compare au jalon 'start'
    --------
  */
   function putTime() {
      var date = new Date()

      setTimeout(function () {
         aQs.push(['timeTotal', date.getTime() - oJalons.start.t.getTime()].join('='))

         // pour récupération coté logs.js
         window.dataStoreHP.webperf = {
            zgifTimeTotal: date.getTime() - oJalons.start.t.getTime()
         }

         // aQs.push(getFmp())
         aQs.push(getCoor())
         aQs.push(getNavigationTiming())

         aZgif.forEach((item) => {
            let zGif = new Image()
            zGif.src = item + aQs.join('&')
         })
      }, 500)
   }

   function ipv6() {
      var rnd = Math.floor(Math.random() * 100000000000)

      for (let i in oIpv6.oImgs) {
         if (oIpv6.oImgs.hasOwnProperty(i)) {
            let hImg = new Image() // eslint-disable-line no-undef
            hImg.src = oIpv6.oImgs[i].src + rnd

            let d = new Date().getTime()

            hImg.addEventListener('load', () => {
               let onloadDate = new Date().getTime()
               oIpv6.oImgs[i].time = onloadDate - d
            })
         }
      }

      setTimeout(function () {
         var finalImg = new Image() // eslint-disable-line no-undef
         var aParams = []
         for (var i in oIpv6.oImgs) {
            if (oIpv6.oImgs.hasOwnProperty(i)) {
               var s = [i, oIpv6.oImgs[i].time].join('=')
               aParams.push(s)
            }
         }
         finalImg.src = oIpv6.finalUrl + aParams.join('&')
         finalImg.setAttribute('style', 'display:none;')
         finalImg.setAttribute('id', 'zgifIPv6')
         document.body.appendChild(finalImg)
      }, 500)
   }

   return {
      run: run,
   }
}
